<div class="relative">

    <!-- NORMAL VIEW -->
    <!-- <div  class="grid lg:grid-cols-4 grid-cols-1 p-4 gap-4 w-full">
      <ng-container *ngFor="let md of data">
          <div *ngIf="md.name!='Dashboard' && md.name != 'Scarica l\'agent'"
              class="card-clickable up-on-hover cursor-pointer pb-5 m-0 w-full" (click)="view(md.route)">

              <div class="flex justify-start items-center">
                  <div *ngIf="md.icon" class="{{md.icon}} h-10 w-10 mr-2"></div>
                  <h2 class="">{{md.name}}</h2>
              </div>

          </div>


      </ng-container>



  </div> -->

    <!-- COMPACT VIEW -->
    <div class="grid lg:grid-cols-8 md:grid-cols-6 sm:grid-cols-3 grid-cols-3  small-screen-dashboard-grid lg:p-4 p-2 lg:gap-4 gap-2 w-full">
        <ng-container *ngFor="let md of data">
            <div *ngIf="md.name!='Dashboard' && md.name != 'Scarica l\'agent'"
                class="flex flex-col justify-stretch items-center text-center">
                <div class="card-clickable rounded-3xl up-on-hover cursor-pointer w-full" tabindex="0" (click)="view(md.route)">

                    <div class="flex flex-col justify-center items-center w-full h-full text-center">
                        <div class="{{md.icon || 'icon-placeholder'}} w-8/12"></div>
                    </div>

                </div>

                <p class="font-medium text-lg lg:text-xl py-2 text-colored">{{md.name}}</p>
            </div>

        </ng-container>



    </div>
</div>

<div *ngIf="stillLoading" class="flex flex-col justify-center items-center text-center">
    <button ejs-button class="dl-button" (click)="reload()">
        <app-animation></app-animation>
    </button>
    <h4>Problemi nel caricamento? Ricarica la pagina </h4>
</div>
